var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.image)?_c('SubTopNav',{attrs:{"title":_vm.title,"image":_vm.image}}):_c('SubTopNav',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"content",attrs:{"id":"htmlBody"},domProps:{"innerHTML":_vm._s(_vm.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }